import { createSlice } from '@reduxjs/toolkit';
import { addDays } from 'date-fns';
import last from 'lodash/last';
import { format, formatArray } from '@services/Date.service';
import OrderFormService from '@services/OrderForm.service';
import { isDate } from '@utils/helpers';

import {
  resetMealtypeTagsReducer,
  resetTagsReducer,
  toggleMealtypeTagReducer,
  toggleTagReducer,
} from './orderForm.actions';

const initialState = {
  calendarVisibleDays: [],
  selectedDate: format(new Date()),
  selectedTags: [],
  selectedMealtypeTags: {},
  userProceed: false,
  useDiscountCode: false,
  discountCode: { '@id': null, value: '' },
  useMoneyBox: false,
  useInvoice: false,
  invoice: {},
  paymentMethod: null,
  blik: '',
};

const orderFormSlice = createSlice({
  name: 'orderForm',
  initialState,
  reducers: {
    setInitialCalendarVisibleDays: (state, { payload }) => {
      state.calendarVisibleDays = payload;
    },
    addCalendarVisibleDays: (state, { payload }) => {
      const { dayNumber, disabledDays, disabledDaysOfWeek } = payload;

      const lastDate = new Date(last(state.calendarVisibleDays));

      if (isDate(lastDate)) {
        const startDay = addDays(lastDate, 1);

        const days = OrderFormService.getDaysRangeByCountWithoutDisabled(
          startDay,
          dayNumber,
          disabledDays,
          disabledDaysOfWeek
        );
        const formattedDays = formatArray(days);

        state.calendarVisibleDays.push(...formattedDays);
      }
    },
    setSelectedDate: (state, { payload }) => {
      state.selectedDate = payload;
    },
    setUserProceed: state => {
      state.userProceed = true;
    },
    resetOrderForm: (_, { payload = {} }) => {
      const { firstPossibleOrderDay = initialState.selectedDate } = payload;

      return {
        ...initialState,
        selectedDate: format(new Date(firstPossibleOrderDay)),
      };
    },
    resetTags: resetTagsReducer,
    toggleTag: toggleTagReducer,
    resetMealtypeTags: resetMealtypeTagsReducer,
    toggleMealtypeTag: toggleMealtypeTagReducer,
  },
});

export const selectOrderForm = state => state.orderForm;

export const {
  addCalendarVisibleDays,
  resetOrderForm,
  resetTags,
  setInitialCalendarVisibleDays,
  setSelectedDate,
  setUserProceed,
  toggleTag,
  resetMealtypeTags,
  toggleMealtypeTag,
} = orderFormSlice.actions;

export default orderFormSlice.reducer;
